/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import Head from 'next/head';
import React from 'react';
import { useSelector } from 'react-redux';

const HeadSection = () => {
  const { fontOverride } = useSelector((store) => store.optionalFormConfig);
  const fontName = fontOverride?.name
    ? fontOverride?.name.replace(' ', '+')
    : null;

  return fontName ? (
    <Head>
      <link
        href={`https://fonts.googleapis.com/css2?family=${fontName}:wght@400;700;900&display=swap`}
        rel="stylesheet"
      />
    </Head>
  ) : null;
};

export default HeadSection;
